// Copyright (c) 2016 Deere & Company

import './pip-code-details.scss';
import React, {PropTypes} from 'react';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerDetails from './customer-details';
import FileAttachmentPanel from '../../../shared/components/file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import PipCodeTypeDetails from './pip-code-type-details';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';

const getServiceConfig = pipProduct => ({
    className: 'REFNO-SERNR',
    classType: 'BO',
    objectKey: `${pipProduct.pipNumber}-${pipProduct.pin}`
});

function handlePipCodeChange(key) {

    const pipCodeSelected = this.pipCodeType.find(item => item.key === key);

    this.onItemChange('pipCodeType', pipCodeSelected);

}

function handleFileUpload(file, dropzone) {

    this.handleFileUploadSuccess(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

const PipCodeDetails = props =>
    <div className='pip-code-details'>
        <section className='pip-code-fields'>
            <CustomerDetails customer={props.customer}/>
            <OptionsDropDown
                className='pip-code-dropdown'
                isPlaceholderTranslated={false}
                isRequired={true}
                label='PIP_CODE'
                onChange={props::handlePipCodeChange}
                optionDisplayAttributes={['value']}
                optionKey='key'
                options={props.pipCodeType}
                placeholder='SELECT_PIP_CODE'
            />
            <PipCodeTypeDetails
                onItemChange={props.onItemChange}
                pipCode={props.pipCode}
            />
            <div className='asterisk-before'>
                <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
            </div>
        </section>
        <section className='file-upload'>
            <FileAttachmentPanel
                files={props.pipCode.file}
                isRequired={false}
                onFileDelete={props.handleFileDelete}
                onFileUploadSuccess={props::handleFileUpload}
                serviceConfig={getServiceConfig(props.pipProduct)}
            />
        </section>
    </div>;

PipCodeDetails.displayName = 'PipCodeDetails';
PipCodeDetails.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    handleFileDelete: PropTypes.func.isRequired,
    handleFileUploadSuccess: PropTypes.func.isRequired,
    onItemChange: PropTypes.func.isRequired,
    onPipCodeChange: PropTypes.func.isRequired,
    pipCode: PropTypes.instanceOf(PipCode).isRequired,
    pipCodeType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired
};

export default PipCodeDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/pip-code-details.js